// Version : 0.0.2
// Author : SATHISH
// LastEdit : NANDHAKUMAR
// MODFIED DATE: 5/12/2025
const ChangeMeetingActionTypes = {
	/** ***************** GET CHANGE MEETING DETAILS START *********************** */
	GET_CHANGE_MEETING_LIST_START: 'get_change_meeting_start',
	GET_CHANGE_MEETING_LIST_SUCCESS: 'get_change_meeting_success',
	GET_CHANGE_MEETING_LIST_FAILURE: 'get_change_meeting_failure',
	GET_CHANGE_MEETING_LIST_RESPONSE_RESET: 'get_change_meeting_response_reset',
	GET_CHANGE_MEETING_LIST_RESPONSE_CHANGED: 'get_change_meeting_response_changed',
	/** ***************** GET CHANGE MEETING DETAILS END *********************** */
};
export default ChangeMeetingActionTypes;
